// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumbs_breadcrumb__BO2ak","breadcrumb__item":"Breadcrumbs_breadcrumb__item__rTxpT"};